module.exports = __webpack_public_path__ + "static/img/3876_phase_function_Paper_PointsHejduk_Prediction.41f21fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3876_phase_function_Paper_PointsHejduk_Prediction.png
// module id = RFRs
// module chunks = 0